import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { collapsedSlice } from '~/store'

const useCollapsedState = (key, id) => {
  const dispatch = useDispatch()

  const [internal, setInternal] = useState(false)

  const setCollapsed = useCallback(
    (collapsed) => {
      if (id) {
        dispatch(collapsedSlice.setCollapsed({ key, id, collapsed }))
      } else {
        setInternal(collapsed)
      }
    },
    [dispatch, id, key]
  )

  const toggleCollapsed = useCallback(() => {
    if (id) {
      dispatch(collapsedSlice.toggleCollapsed({ key, id }))
    } else {
      setInternal((collapsed) => !collapsed)
    }
  }, [dispatch, id, key])

  const collapsed = useSelector((state) =>
    collapsedSlice.isCollapsed(state, key, id)
  )

  return useMemo(() => {
    return {
      collapsed: id ? !!collapsed : internal,
      setCollapsed,
      toggleCollapsed,
    }
  }, [collapsed, id, internal, setCollapsed, toggleCollapsed])
}

export default useCollapsedState
